import React, { Component, PropTypes } from 'react';
import $ from 'jquery';
import Modal from 'common/components/Modal';
import PointForm from './forms/PointForm';
import MarkerForm from './forms/MarkerForm';
import CommentForm from './forms/CommentForm';
import 'plugins/forms';
import cx from 'classnames';

class EditPointModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isUpdating: false,
      isDeleting: false,
    };

    this._onChangeImage = this._onChangeImage.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._onDelete = this._onDelete.bind(this);
  }

  _onChangeImage(file) {
    this._file = file;
  }

  _onSubmit(evt) {
    const { point } = this.props;

    evt.preventDefault();

    const $form = $(evt.target)
      .closest('.modal')
      .find('form');
    const data = $form.serializeObject();

    this.props.onSave(
      {
        ...point,
        ...data,
      },
      this._file
    );

    this.setState({
      isUpdating: true,
    });
  }

  _onDelete(evt) {
    const { point } = this.props;

    evt.preventDefault();

    this.props.onDelete(point);

    this.setState({
      isDeleting: true,
    });
  }

  render() {
    const { point, disabled, onClose } = this.props;
    const { isDeleting, isUpdating } = this.state;

    let content;

    if (point.type === 'point') {
      content = <PointForm point={point} disabled={disabled} />;
    } else if (point.type === 'marker') {
      content = <MarkerForm point={point} disabled={disabled} />;
    } else {
      content = (
        <CommentForm
          comment={point}
          disabled={disabled}
          onChangeImage={this._onChangeImage}
        />
      );
    }

    const deleteClassName = cx('ui button red icon labeled left floated', {
      loading: isDeleting,
    });

    const updateClassName = cx('ui primary button icon labeled', {
      loading: isUpdating,
    });

    return (
      <Modal isOpened closable onClose={onClose}>
        <div className="header">{point.name}</div>
        <div className="content">{content}</div>
        {!disabled && (
          <div className="actions">
            <button className={deleteClassName} onClick={this._onDelete}>
              <i className="icon trash" />
              Supprimer
            </button>
            <button className={updateClassName} onClick={this._onSubmit}>
              <i className="icon save" />
              Enregistrer
            </button>
          </div>
        )}
      </Modal>
    );
  }
}

EditPointModal.propTypes = {
  point: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default EditPointModal;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/components/EditPointModal.js